import baseConfig from './base';

const config = {
  // apiUrl: "http://api.multi-stream.test"
};

export default Object.freeze(Object.assign({}, baseConfig, config));